import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BfAuthGuard } from '@brafton/skynet-angular-security-service';

const routes: Routes = [
  {
    path: 'projects',
    loadChildren: () => import('./projects/projects.module').then((m) => m.ProjectsModule),
  },
  {
    path: 'produce',
    loadChildren: () => import('./projects/projects.module').then((m) => m.ProjectsModule),
  },
  {
    path: 'plan',
    loadChildren: () => import('./projects/projects.module').then((m) => m.ProjectsModule),
  },
  {
    path: 'my',
    loadChildren: () => import('./my/my.module').then((m) => m.MyModule),
  },
  {
    path: 'team',
    loadChildren: () => import('./team/team.module').then((m) => m.TeamModule),
  },
  {
    path: 'content',
    loadChildren: () => import('./content/content.module').then((m) => m.ContentModule),
  },
  {
    path: 'sows',
    loadChildren: () => import('./sow/sow.module').then((m) => m.SowModule),
  },
  {
    path: 'campaigns',
    loadChildren: () => import('./campaigns/campaign.module').then((m) => m.CampaginModule),
  },
  {
    path: 'orgs',
    loadChildren: () => import('./organizations/org.module').then((m) => m.OrgModule),
  },
  {
    path: 'profile',
    loadChildren: () => import('./profile/profile.module').then((m) => m.ProfileModule),
  },
  {
    path: 'messages',
    loadChildren: () => import('./messages/messages.module').then((m) => m.MessagesModule),
  },
  {
    path: 'search',
    loadChildren: () => import('./search/search.module').then((m) => m.SearchModule),
  },
  {
    // Catalog viewer (Work Issues #153 / #156): all @brafton/angular-catalog-library wiring
    // — the DI providers and CATALOG_VIEWER_ROUTES — lives behind this dynamic import so the
    // library is only pulled into a lazy chunk, never into main.js. See viewer-routes.ts.
    path: 'viewer',
    canActivate: [BfAuthGuard],
    title: 'Viewer',
    loadChildren: () => import('./viewer/viewer-routes').then((m) => m.VIEWER_ROUTES),
  },
  // Fallback Routes
  {
    path: 'editorial',
    redirectTo: 'produce',
  },
  {
    path: 'designs',
    redirectTo: 'produce',
  },
  {
    path: 'social',
    redirectTo: 'produce',
  },
  {
    path: 'consulting',
    redirectTo: 'produce',
  },
  {
    path: 'tech',
    redirectTo: 'produce',
  },
  {
    path: 'videos',
    redirectTo: 'produce',
  },
  {
    path: 'account-manager',
    redirectTo: 'produce',
  },
  {
    path: 'contracts/contract-details',
    redirectTo: 'sows',
  },
  {
    path: 'contracts',
    redirectTo: 'sows',
  },
  {
    path: 'test',
    loadChildren: () => import('./test/test.module').then((m) => m.TestModule),
  },
  {
    path: 'text',
    loadChildren: () => import('./text-set/text-set.module').then((m) => m.TextSetModule),
  },
  {
    path: 'tools',
    loadChildren: () => import('./tools/tools.module').then((m) => m.ToolsModule),
  },
];

@NgModule({
  // paramsInheritanceStrategy is pinned to 'emptyOnly' deliberately. Angular 22 changed the
  // default to 'always', which makes every child route inherit its parents' params and data
  // even when the child declares its own — a silent behaviour change with no migration, and
  // this app resolves route params at many nesting levels. Pinning the pre-v22 value keeps the
  // upgrade behaviour-preserving; moving to 'always' should be its own audited change.
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'reload',
      paramsInheritanceStrategy: 'emptyOnly',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
